import axios from "axios"
import { APIURL } from "../Constantes"
import { getCabecera } from "../utils/getCabecera"

const urlHotel = "Hotel"

export const getHotelCotizacion = async ({IdCotizacion}) =>{
    return axios.get(`${APIURL}/${urlHotel}/Quotation/${IdCotizacion}`, 
    {
        headers: getCabecera()
    }).then((Response) =>{
        return Response.data;
    }).catch((Error) =>{
        //return Error.response.data;
        return [];
    })
}